import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020493c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("全部")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DefaultOptionSelect = _resolveComponent("DefaultOptionSelect")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_FormDialog = _resolveComponent("FormDialog")!

  return (_openBlock(), _createBlock(_component_FormDialog, {
    ref: "formDialogRefs",
    title: _ctx.type=='batch'? '批量编辑': '编辑',
    width: "50%",
    labelWidth: "120px",
    formData: _ctx.editFormData,
    rules: _ctx.rules,
    showErrorToast: false,
    validateOnRuleChange: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visibleRef) = $event)),
    saveForm: _ctx.saveFormHandle
  }, {
    default: _withCtx(() => [
      (_ctx.type!='batch')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "员工姓名",
            prop: "staffName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入员工姓名",
                modelValue: _ctx.editFormData.staffName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editFormData.staffName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.type!='batch')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "员工手机号",
            prop: "staffPhone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "请输入员工手机号",
                disabled: "",
                modelValue: _ctx.editFormData.staffPhone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editFormData.staffPhone) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        label: "选择角色",
        prop: "roleIdList"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DefaultOptionSelect, {
            "dictionary-key": "",
            multiple: true,
            defaultOptions: _ctx.roles,
            valueKey: "roleId",
            labelKey: "roleName",
            modelValue: _ctx.editFormData.roleIdList,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editFormData.roleIdList) = $event))
          }, null, 8, ["defaultOptions", "modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "电子面单账号",
        prop: "partnerIdList"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.checkAll,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkAll) = $event)),
            indeterminate: _ctx.isIndeterminate,
            onChange: _ctx.handleCheckAllChange
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["modelValue", "indeterminate", "onChange"]),
          _createVNode(_component_el_checkbox_group, {
            modelValue: _ctx.editFormData.partnerIdList,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editFormData.partnerIdList) = $event)),
            onChange: _ctx.handleCheckedPartnerIdChange
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnerIdOptions, (item, index) => {
                return (_openBlock(), _createBlock(_component_el_checkbox, {
                  key: index,
                  label: item.partnerId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.partnerId), 1)
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "formData", "rules", "visible", "saveForm"]))
}